import { useContext } from 'react';
import { usePathname, useRouter } from 'next/navigation';
import { ScreenSizeContext } from '@context';
import { NavLink } from '@general';
import { Account, Droplet, MeterHouse, Work } from '@public';
import { Arrow } from '@public/icons';

import { SideBarItemType } from '@/types';

import styles from './sidebarList.module.scss';

export interface SideBarItemProps {
	menuItem: SideBarItemType;
	selected: boolean;
}

export const SideBarItem = ({
	menuItem: { name, url, subItems, id, icon, disabled },
	selected,
}: SideBarItemProps) => {
	const router = useRouter();
	const pathname = usePathname();
	const { isSmallDT } = useContext(ScreenSizeContext);
	const isNested = subItems && subItems?.length > 0;
	selected = router ? pathname === url : selected;

	const ICONS: {
		[key: string]: React.ReactNode;
	} = {
		meterHouse: <MeterHouse customStyles={styles['sideBar-item-mobile-icon']} />,
		account: <Account customStyles={styles['sideBar-item-mobile-icon']} />,
		droplet: <Droplet customStyles={styles['sideBar-item-mobile-icon']} />,
		works: <Work customStyles={styles['sideBar-item-mobile-icon']} />,
	};

	const createItem = () => {
		return isSmallDT ? horizontalItem() : verticalItem();
	};

	const horizontalItem = () => {
		return (
			<button
				className={[
					styles['sideBar-item-mobile-container'],
					disabled ? styles['sideBar-item-mobile-disabled'] : styles['sideBar-item-mobile-enabled'],
				].join(' ')}
				clasaria-label={name}
				tabIndex={0}
			>
				{icon && <>{ICONS[icon]}</>}
				<p>{name}</p>
			</button>
		);
	};

	const verticalItem = () => {
		return (
			<div
				className={[
					styles['sideBar-item-container'],
					selected ? styles['sideBar-item-container-selected'] : '',
					disabled ? styles['sideBar-item-container-disabled'] : '',
				].join(' ')}
				key={id}
			>
				<div>
					<p className={styles[`sideBar-item-name`]}>{name}</p>
				</div>
				{selected && (
					<button
						className={styles[`sideBar-item-button-${selected && 'show'}`]}
						aria-label={name}
						tabIndex={0}
					>
						<Arrow customStyles={styles['sideBar-item-button']} />
					</button>
				)}
				{isNested ? (
					<button
						className={styles[`sideBar-item-button-${isNested && 'show'}`]}
						aria-label={name}
						tabIndex={0}
					>
						<Arrow customStyles={styles['sideBar-item-button']} />
					</button>
				) : null}
			</div>
		);
	};

	return !disabled ? <NavLink href={url}>{createItem()}</NavLink> : createItem();
};
